import React, { useState, useEffect } from 'react';
import '../styles/Home.css';
import SquadGrid from '../components/SquadGrid';
import { useLocation, useParams } from 'react-router-dom';
import { Header } from '../components/Header';

export const Squad = () => {

    let { squadName } = useParams<"squadName">();
    const location = useLocation();

    const [squad, setSquad] = useState(null);

    useEffect(() => {
        const id = location.hash.substring(1);
        document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
      }, [location.hash]);

    useEffect(() => {
        if (squadName) {
            let squad_name = squadName;
            import(`../constants/squads/${squad_name}.ts`)
                .then((module) => {
                    let raw_squad = module[squad_name];
                    for (let player of raw_squad) {
                        player["age"] = calculateAge(player["birth_date"])
                        setSquad(raw_squad);
                    }
                })
                .catch((error) => {
                    console.error(`An error occurred while loading the squad data: ${error}`);
                });
            
            const id = location.hash.substring(1);
            if (id) {
                // Wait a bit to ensure the element has been rendered
                setTimeout(() => {
                    const element = document.getElementById(id);

                    if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                    } 
                }, 1000); // Adjust the delay as needed
            }
        }
    }, [location.hash, squadName]);

    const calculateAge = (birthdate: string): number => {
        const birthday = new Date(birthdate);
        const today = new Date();

        let age = today.getFullYear() - birthday.getFullYear();
        const m = today.getMonth() - birthday.getMonth();

        if (m < 0 || (m === 0 && today.getDate() < birthday.getDate())) {
            age--;
        }

        return age;
    }

    return (
        <div style={{
            paddingTop: '20px',
            paddingBottom: '20px',
            paddingLeft: '40px',
            paddingRight: '40px'
        }}>
            {squadName && <Header title={squadName?.replace('_', " ").toUpperCase()} isSquadPage />}
            {squad && <SquadGrid squad={squad} />}
        </div>
    );
};